export default __webpack_public_path__ + "static/madcapsoftware-9801b7ab7c852cab30d4165d100129aa.svg";